const booleanify = (value: string): boolean => {
  const truthy: string[] = ['true', 'True', '1']

  return truthy.includes(value)
}

const capitalizeFirstLetter = (text: string): string => {
  if (!text) return ''
  return text.charAt(0).toUpperCase() + text.slice(1)
}

const UtilFunctions = {
  booleanify,
  capitalizeFirstLetter,
}

export default UtilFunctions
